import { TABLA_CARGA_BUQUES } from '../../../config/tables'
import { COLUMNS_CARGA_BUQUES } from './constantesBuque'
import { CargaBuque } from '../../../models/buque/carga_buque'
import { getFormValues, reset } from 'redux-form'
import { FORM_BUQUES } from '../../../config/forms'
import { toast } from 'react-toastify'
import { actualizarDatosParaMuiTable } from './TablaBuquesAnunciadosActions'
import { parseEntityId } from '../../../models/entity'
import moment from 'moment'

export function parseData (data) {
  const parsedData = []
  for (const entry of data) {
    parsedData.push({ ...entry, entry: entry })
  }
  return parsedData
}

export function actualizarTabla (data, titulo) {
  return (dispatch) => {
    const customToolbar = null

    return dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        columns: COLUMNS_CARGA_BUQUES,
        data: data,
        title: titulo,
        isLoading: false,
        fixed2Decimales: false,
        extraOptions: { customToolbar, print: false, pagination: false }
      },
      id: TABLA_CARGA_BUQUES
    })
  }
}

export function actualizarDatosCargaBuques () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CARGA_BUQUES
    })
    CargaBuque.obtenerCargaDiariaBuques().then(callback)
    async function callback (d) {
      const data = parseData(d)
      const titulo = 'Detalle de carga de buques'
      dispatch(actualizarTabla(data, titulo))
    }
  }
}

export function obtenerDetalleDeCarga (fechaAnuncio) {
  return (dispatch) => {
    CargaBuque.obtenerDetalleCarga(fechaAnuncio)
      .then((d) => {
        if (!d.error) {
          const data = parseData(d)
          dispatch({ type: 'RECEIVE_DETALLE_CARGA', data })
          const titulo = 'Detalle de carga de buque'
          dispatch(actualizarTabla(data, titulo))
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }
}

export function resetDetalleCarga () {
  return (dispatch) => {
    dispatch({ type: 'RESET_DETALLE_CARGA' })
    dispatch(actualizarDatosParaMuiTable())
    dispatch(actualizarDatosCargaBuques())
    dispatch(actualizacionAnuncioCarga(true))
  }
}

export function actualizacionAnuncioCarga (newValue) {
  return (dispatch) => {
    dispatch({ type: 'ACTUALIZACION_COMPLETA', newValue })
  }
}

export function parseValues (formValues) {
  return () => {
    if (formValues.exportador) {
      formValues.cuitExportador = parseEntityId(formValues.exportador)
      formValues.exportadorOld = parseEntityId(formValues.exportadorOld)
    }
    return formValues
  }
}

export function agregarDetalleCarga (detalle) {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_BUQUES)(state)
    const fechaAnuncio = formValues.fechaAnuncio
    detalle.map(async (d) => {
      const values = dispatch(parseValues(d))
      try {
        const result = await CargaBuque.altaDetalleCarga(values)
        dispatch(obtenerDetalleDeCarga(fechaAnuncio))
        if (result.error) {
          toast.error('Error al intentar guardar detalle de carga')
        }
      } catch (error) {
        console.log(error)
        toast.error('Error al intentar guardar detalle de carga')
      }
    })
  }
}

export function actualizarDetalleCarga () {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_BUQUES)(state)
    const values = dispatch(parseValues(formValues))
    const fechaAnuncio = formValues.fechaAnuncio
    const fechaCarga = formValues.fechaCargaOld || formValues.fechaCarga
    const cereal = formValues.cerealOld || formValues.cereal
    const exportador = formValues.exportadorOld

    return CargaBuque.updateDetalleCarga(values, fechaAnuncio, fechaCarga, exportador, cereal)
      .then((data) => {
        if (!data.error) {
          // toast.success('El detalle de carga fue actualizado correctamente.')
          dispatch(obtenerDetalleDeCarga(fechaAnuncio))
          dispatch(obtenerCargasBuque())
        } else {
          toast.error('Error al intentar modificar detalle de carga')
        }
        dispatch(reset(FORM_BUQUES))
      })
      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar modificar detalle de carga')
      })
  }
}

export function eliminarDetalleCarga (fechaAnuncio, fechaCarga, exportador, cereal) {
  return (dispatch) => {
    return CargaBuque.deleteDetalleCarga(fechaAnuncio, fechaCarga, exportador, cereal)
      .then((result) => {
        if (!result.error) {
          dispatch(obtenerDetalleDeCarga(fechaAnuncio))
        } else {
          toast.error('Error al intentar eliminar detalle de carga')
        }
      })
      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar eliminar detalle de carga')
      })
  }
}

export function parseDataCalendar (data) {
  const parsedData = []
  const hoy = moment(new Date()).format('YYYY-MM-DD')

  const totalesPorFechaAnuncio = {}

  data && data.forEach((d) => {
    const fechaAnuncio = d.fechaAnuncio
    const toneladas = d.toneladas || 0
    totalesPorFechaAnuncio[fechaAnuncio] = (totalesPorFechaAnuncio[fechaAnuncio] || 0) + toneladas
  })

  data && data.map((d) => {
    const totalAnunciado = totalesPorFechaAnuncio[d.fechaAnuncio] || 0

    if (d.fechaDeCarga >= hoy) {
      const id = `${d.buque}-${d.nombreExportador}-${d.fechaDeCarga}-${d.claveCereal}`
      parsedData.push({ ...d, id: id, totalAnunciado: totalAnunciado })
    }
    return parsedData
  })
  return parsedData
}

export function obtenerCargasBuque () {
  return (dispatch) => {
    return CargaBuque.obtenerCargaDiariaBuques().then(callback)
    async function callback (d) {
      const data = parseDataCalendar(d)
      const uniqueCereals = new Set()

      data.forEach(item => {
        uniqueCereals.add(item.claveCereal.trim())
      })

      const cereales = Array.from(uniqueCereals)
      dispatch({ type: 'RECEIVE_CARGAS_BUQUE', data, cereales })
    }
  }
}
